module.exports = __webpack_public_path__ + "img/75.2e0017cd.jpg";